<template>
  <div class="landing">
    <h1 class="title">{{ $t('welcome.title') }}</h1>
    <button @click="startGenerate">{{ $t('welcome.generateButton') }}</button>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()
const startGenerate = () => {
  router.push('/generate')
}
</script>

<style scoped>
.landing {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
}

h1 {
  margin-bottom: 2rem;
}

button {
  background-color: #00cc44;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  font-weight: bold;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  margin: 1rem;  /* Add spacing around buttons */
}

button:hover {
  background-color: #00b33c;
}

.language-selector {
  margin-top: 2rem;  /* Add space above language selector */
}
</style>
